import type { weCare } from '../../../../app/_shared/marketing/landingContent';
import { heroRooftop } from '../../assets/marketing/marketingSceneExport';
import { ComfortGlyph } from '../ember/ComfortGlyph';
import { withEmphasis } from './emphasisText';
import './landingRef.css';

type CheckItem = (typeof weCare.checklist)[number];

type Props = {
  h2: string;
  body: string;
  learnMoreLabel: string;
  learnMoreHref: string;
  checklist: readonly CheckItem[];
};

export function SafetyTrustPanel({ h2, body, learnMoreLabel, learnMoreHref, checklist }: Props) {
  const bodyParagraphs = body.split('\n\n').filter(Boolean);

  return (
    <section className="safety-section">
      <div className="safety-copy">
        <h2 className="ml-heading-serif">{h2}</h2>
        {bodyParagraphs.map((para) => (
          <p key={para}>{withEmphasis(para)}</p>
        ))}
        <a href={learnMoreHref}>{learnMoreLabel} →</a>
      </div>

      <div className="safety-visual">
        <div
          className="safety-image"
          style={{ backgroundImage: `url(${heroRooftop})` }}
          role="img"
          aria-label="Warm evening social setting"
        />
        <div className="safety-card">
          {checklist.map((item) => (
            <div key={item.label}>
              <span className="safety-card__icon" aria-hidden>
                <ComfortGlyph kind={item.glyph} label={item.label} />
              </span>
              <strong>{item.label}</strong>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
